// Code review - In Progress
// Documentation - In Progress
import React, { useState } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";

const DropDown = (props) => {
  const [error, setError] = useState("");

  const handleBlur = (e) => {
    const { value } = e.target;
    let errorMessage = "";

    if (props.isRequired && !value) {
      errorMessage = `Select ${props.title}`;
    } else if (props.controlFuncBlur) {
      errorMessage = props.controlFuncBlur(e) || "";
    }

    setError(errorMessage);
  };

  return (
    <div className={props.classDiv ? props.classDiv : "form-group"}>
      <label className={props.ClassLabel ? props.ClassLabel : mainTable.label}>
        {props.title}
        {props.classStar && (
          <span className={props.classStar ? props.classStar : "hidden"}>
            *
          </span>
        )}
      </label>

      <select
        name={props.name}
        typeof={props.type}
        value={props.selectedOption}
        onChange={props.controlFunc}
        onBlur={props.controlFuncBlur}
        className={`${props.Class ? props.Class : mainTable.input} ${
          props.disabled ? "bg-gray-50 cursor-not-allowed" : ""
        }`}
        disabled={props.disabled}
        tabIndex={props.tabIndex}
      >
        {props.placeholder && (
          <option value="" disabled >
            {props.placeholder}
          </option>
        )}
        {Array.isArray(props.options) &&
          props.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
      </select>
      {props.errorMessage && (
        <span className="text-red-500 text-sm font-medium">
          {props.errorMessage}
        </span>
      )}
    </div>
  );
};

DropDown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedOption: PropTypes.string.isRequired,
  controlFunc: PropTypes.func.isRequired,
  controlFuncBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  classDiv: PropTypes.string,
  ClassLabel: PropTypes.string,
  classStar: PropTypes.string,
  Class: PropTypes.string,
  type: PropTypes.string,
};

DropDown.defaultProps = {
  disabled: false,
  isRequired: false,
};

export default DropDown;
